"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAvailability = void 0;
const utils_1 = require("./utils");
/**
 * Parses 'configuration' and 'days' fields from the experience-api-lodging-availability response into a format usable by the UI components that compose the Availability Date Selector
 * @function
 * @param {ParserInputConfig} configuration - the configuration field from the experience-api-lodging-availability propertyAvailabilityCalendars query response
 * @param {Array<ParserInputDate>} days - the 'days' field from the experience-api-lodging-availability propertyAvailabilityCalendars query response
 * @param {string} checkInDate - Optional. Selected check-in date in YYYY-MM-DD format, when requesting checkout availability data
 * @returns {ParserOutput}
 */
function parseAvailability({ configuration, days, checkInDate, }) {
    const { availableByDefault, beginDate, defaultCheckinValidityAfterEndDate, defaultStayConstraints, endDate, } = configuration;
    let dateIndex = -1;
    let previousDayAvailable = false;
    const timeProgression = {
        daysSinceCheckIn: -1,
        isAfterCheckIn: false,
        minStayMet: false,
        maxStayWindowExceeded: false,
    };
    const stayConstraints = {
        minStay: 0,
        maxStay: 0,
    };
    let thisDay = {
        dateObj: new Date((0, utils_1.convertDashesToSlashes)(beginDate)),
        dateText: (0, utils_1.convertDateObjToString)(beginDate),
    };
    const endDay = {
        dateObj: new Date((0, utils_1.convertDashesToSlashes)(endDate)),
        dateText: (0, utils_1.convertDateObjToString)(endDate),
    };
    const checkInDay = {
        dateObj: new Date((0, utils_1.convertDashesToSlashes)(checkInDate)),
        dateText: checkInDate,
    };
    const output = {
        // These defaults make check-in and checkout either all available or all not available based on the check-in validity
        // We might want to consider in the future a solution where we use defaults to output check-in/checkout data for a defined date range so that we can calculate more accurate checkout validity
        defaults: {
            availability: availableByDefault ? 'available' : 'unavailable',
            minStay: defaultStayConstraints.minimumStayInDays,
            isSelectable: availableByDefault,
            selectabilityMessage: defaultCheckinValidityAfterEndDate,
        },
    };
    while (+thisDay.dateObj <= +endDay.dateObj) {
        dateIndex++;
        // shared values with checkin + checkout
        thisDay.availability = (0, utils_1.getAvailability)(previousDayAvailable, days[dateIndex].available);
        thisDay.minStay = days[dateIndex].stayConstraints.minimumStayInDays;
        if (!checkInDate) {
            (0, utils_1.getSelectabilityForCheckIn)({ dateIndex, days, thisDay });
        }
        else {
            (0, utils_1.getSelectabilityForCheckout)({
                checkInDay,
                dateIndex,
                days,
                stayConstraints,
                thisDay,
                timeProgression,
            });
        }
        // output calculated selectability
        const { dateObj } = thisDay, thisDayOutput = __rest(thisDay, ["dateObj"]);
        const newDate = Object.assign({ dateObj: new Date((0, utils_1.convertDashesToSlashes)(thisDayOutput.dateText)) }, thisDayOutput);
        output[thisDay.dateText] = newDate;
        previousDayAvailable = days[dateIndex].available;
        thisDay = (0, utils_1.getNextDay)(thisDay.dateObj);
    }
    return output;
}
exports.parseAvailability = parseAvailability;
